<!--
  Component: Field Calculation Modal: Lookup Pair.
  Path:      Field - Calculation - Lookup - Pair.
  Pair:      Source Field:  Non-Lookup Fields in current table.
  .          Related Field: Same Data Type Field in related table.
-->
<template>
  <div>
    <b-form-group
      :key="index + 1"
      class="col-sm-5"
    >
      <select
        id="configureSourceField"
        ref="type"
        v-model="lookupPair.sourceField"
        class="mr-sm-2 custom-select"
      >
        <option
          v-for="option in sourceFieldOptions"
          :id="$options.filters.displayName(option.displayName)"
          :value="option.fieldGuid"
        >
          {{ option.displayName }}
        </option>
      </select>
    </b-form-group>
    <span>=</span>
    <b-form-group
      :key="index + 3"
      class="col-sm-5"
    >
      <select
        id="configureFieldRelatedTableColumn"
        ref="type"
        v-model="lookupPair.relatedField"
        class="mr-sm-2 custom-select"
      >
        <option
          v-for="option in relatedFieldOptions"
          :id="$options.filters.displayName(option.displayName)"
          :value="option.fieldGuid"
        >
          {{ option.displayName }}
        </option>
      </select>
    </b-form-group>

    <div class="col-sm-1 ml-auto">
      <b-button
        variant="link"
        pill
        class="btn-delete text-danger"
        title="Remove the Relation"
        @click="deleteLookupPair(index)"
      >
        <font-awesome-icon :icon="'trash'" />
      </b-button>
    </div>
  </div>
</template>

<script>

  export default {

    name: 'LookupPair',

    components: {
    },

    inject:[
      /* Current Table. [from CalculationModel] */
      'table',
      /* Current Field. [from CalculationModel] */
      'tableField',
      /* All Fields across all Modules/Folders. [from CalculationModel] */
      'fields',
      /* Remove a Lookup Pair from the list by index. */
      'deleteLookupPair',
      /* Entity utility functions etc. [from CalculationModel] */
      'entityUtils',
    ],

    props: {
      table: Object,
      lookupPair: Object,
      index: Number,
    },

    data(){
        return {
        };
    },

    computed: {

      /**
       * Dropdown options for 'Source Field'.
       * - Non-Lookup fields.
       * - Fields with a Calculation?
       * - ot the current Field.
       */
      sourceFieldOptions() {
        return this.table.fields.filter(tf => {
          return !this.entityUtils.dataTypeIsLookup(tf.dataTypeName) && ('calculation' in tf) && tf.fieldGuid !== this.tableField.fieldGuid;
        });
      },

      /**
       * Dropdown options for 'Related Field'.
       */
      relatedFieldOptions() {

        /* Selected 'Source Field'. */
        const sourceGuid = this.lookupPair.sourceField
        const sourceField = this.table.fields.find(f => f.fieldGuid === sourceGuid);
        const sourceFieldType = this.entityUtils.getFieldDataType(sourceField);

        /* Lookup Field & Table */
        const relatedField =
          this.fields.data.find(elem => (elem.fieldGuid === this.tableField.dataTypeJSON.FieldToDisplayGuid));
        const relatedTableGuid = relatedField?.entityGuid;
        const fieldsInRelatedTable = this.fields.data.filter(elem => elem.entityGuid === relatedTableGuid);

        let options = [];
        if (fieldsInRelatedTable && sourceFieldType) {
          if (this.entityUtils.dataTypeIsLookup(sourceFieldType)) {
            /*
              Source Field is Lookup.
              NB This shouldn't be possible as Lookup Fields are excluded from the 'Source Field' dropdown.
            */
            options = fieldsInRelatedTable.filter(elem => (
              /* Related Field must be same Data Type as Source Field. */
              elem.dataTypeName === sourceFieldType
              /* Related Field must have same Display Field. */
              && JSON.parse(elem.dataTypeJSON).FieldToDisplayGuid === sourceField.dataTypeJSON.FieldToDisplayGuid
            ));
          }
          else {
            /* Non-Lookup Source Field - Related Field must be Data Type as Source Field. */
            options = fieldsInRelatedTable.filter(elem => elem.dataTypeName === sourceFieldType);
          }
        }
        /* If the 'Related Field' is no longer in the list of options, clear it. */
        if (!options.find(opt => opt.fieldGuid === this.lookupPair.relatedField))
          this.lookupPair.relatedField = '';
        return options;
      },
    },

    methods: {
    },

  }

</script>
